import type { Section } from "../types";
import { g2Reader } from "./products/g2Reader";
import { g2ReaderPro } from "./products/g2ReaderPro";
import { g3Intercom } from "./products/g3Intercom";
import { g3Reader } from "./products/g3Reader";
import { g3ReaderFlex } from "./products/g3ReaderFlex";
import { g3ReaderPro } from "./products/g3ReaderPro";
import { intercom } from "./products/intercom";
import { readerAccessUltra } from "./products/readerAccessUltra";
import { retrofitReader } from "./products/retrofitReader";
import {
  cameraReader,
  dimensions,
  directory,
  hand,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "./properties";

export const Readers: Section = {
  properties: [
    dimensions,
    cameraReader,
    twoWayIntercom,
    directory,
    touchPassSupport,
    pinAccess,
    nfcCard,
    mobileAppAccess,
    hand,
    outdoorReady,
    readerPowerMethod,
  ],
  products: [
    g3ReaderPro,
    g3ReaderFlex,
    g3Reader,
    g3Intercom,
    intercom,
    retrofitReader,
    readerAccessUltra,
    g2ReaderPro,
    g2Reader,
  ],
  columnWidth: 260,
  propertyColumnWidth: 210,
  showBadges: true,
};
